import { event, NewLaneProperties } from '@zillow/universal-analytics';
import { isSyntheticTest } from 'src/utils/validators/isSyntheticTest';
import { trackZepEvent } from './trackZepEvent';

export const trackEvent = (...args: Parameters<typeof event>) => {
    if (isSyntheticTest()) {
        return;
    }

    const clickstreamEvent = args[0] as NewLaneProperties;
    trackZepEvent(clickstreamEvent);
    event(...args);
};
